import React from "react";

const Stock = ({ stock }) => {
  return <td className="text-center">{stock}</td>;
};

export default Stock;
